module.exports = __webpack_public_path__ + "static/img/animals10.ca63716e.png";